import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import SpanNcBarPrice from './price/SpanNcBarPrice';
import SpanNcInfoPrice from './price/SpanNcInfoPrice';
import { setPriceAction } from '../../modules/common/prodModule';

const PriceFilterBlock = styled.div``;

/**
 * 가격 필터 컴포넌트
 * 
 */
const PriceFilter = () => {

    const dispatch = useDispatch();
    const [curPrice, setCurPrice] = useState([0, 0]);

    // const Slider = require('rc-slider');
    // const createSliderWithTooltip = Slider.createSliderWithTooltip;
    // const Range = createSliderWithTooltip(Slider.Range);

    const { priceStats } = useSelector(
        ({ prodItemsReducer }) => ({
            priceStats: prodItemsReducer.priceStats
        })
    );

    useEffect(() => {
        // console.log("변경 !!!! Refresh " + priceStats.min_price.value + "," + priceStats.max_price.value)
        if (priceStats !== null && priceStats !== undefined) {
            setCurPrice([priceStats.min_price.value, priceStats.max_price.value]);
        }
    }, [priceStats])


    const handleChange = (value) => {
        setCurPrice(value);
    }

    const handleAfterChange = (value) => {
        // console.log("handleAfterChange : " + value);
        // 서버에 요청 하기 
        let arrPrice = value.splice(',');
        dispatch(setPriceAction({ min: arrPrice[0], max: arrPrice[1] }));
    }

    if (priceStats === null || priceStats === undefined) {
        return <PriceFilterBlock />
    }

    return (
        <PriceFilterBlock>
            <div className="tf-item clearfix">
                <span className="tf-title">가격</span>
                <ul className="tf-list clearfix">
                    <li>
                        <span className="tag_s-item pay-all" data-tag="가격 전체">
                            전체
                        <button type="button" className="tag_s-delete"></button>
                        </span>
                    </li>
                    <li>
                        <div className="num_control-wrap">
                            <div className="num_control-box clearfix">
                                <div className="nc_bar">
                                    {
                                        <Range min={priceStats.min_price.value} max={priceStats.max_price.value}
                                            defaultValue={curPrice}
                                            value={curPrice}
                                            step="10000"
                                            trackStyle={[{ backgroundColor: '#ffe7ad' }]}
                                            handleStyle={[{ borderColor: '#ffc742' }, { borderColor: '#ffc742' }]}
                                            onChange={handleChange}
                                            onAfterChange={handleAfterChange}
                                            allowCross={false} />
                                    }
                                    <span className="nc_bar-value gray"></span>
                                    <span className="nc_bar-value current"></span>
                                    <SpanNcBarPrice value={priceStats.min_price.value} isMax={false} />
                                    <SpanNcBarPrice value={priceStats.max_price.value} isMax={true} />
                                </div>

                                <SpanNcInfoPrice
                                    minValue={curPrice[0] === 0 ? priceStats.min_price.value : curPrice[0]}
                                    maxValue={curPrice[1] === 0 ? priceStats.max_price.value : curPrice[1]} />

                            </div>
                        </div>
                    </li>

                </ul>
            </div>
        </PriceFilterBlock>
    );
};

export default PriceFilter;